module.exports = "/mobile-phones-illustration4748dea3fcd4fb44c3e5aeab77ccec77.svg";